import {useDispatch, useSelector} from "react-redux";
import {getAbTestsSelector} from "../../app/appSelectors";
import { addAbTestToIsUsedQueueAction } from "../../app/appActions";
import useEffectOnce from "../../hooks/useEffectOnce";

export const useAbTestOption = (abTestName) => {
    const abTests = useSelector(getAbTestsSelector);
    const dispatch = useDispatch();

    useEffectOnce(() => {
        const currentAbTest = abTests[abTestName];
        if (currentAbTest && !currentAbTest.is_used) {
            dispatch(addAbTestToIsUsedQueueAction(abTestName));
        }
    });

    return abTests[abTestName]?.option;
};
